class Dropdown {
    private menuItems: NodeListOf<HTMLElement>;

    constructor(private dropdown: HTMLElement, private button: HTMLElement) {
        this.menuItems = this.dropdown?.querySelectorAll('ul.menu li.menu-item');

        this.menuItems.forEach(item => {
            const subMenu = item.querySelector('ul.sub-menu');

            if (!subMenu) {
                item.addEventListener('click', () => {
                    this.close();
                });
            }
        })

        this.button?.addEventListener('click', () => {
            this.dropdown.classList.contains('show') ? this.close() : this.open();
        });
    }

    close() {
        const icon = this.button.querySelector('i');
        this.dropdown.classList.remove('show');
        icon?.classList.remove('fa-xmark');
        icon?.classList.add('fa-bars');
    }

    open() {
        const icon = this.button.querySelector('i');
        this.dropdown.classList.add('show');
        icon?.classList.remove('fa-bars');
        icon?.classList.add('fa-xmark');
    }
}

window.addEventListener('load', () => {
    const toggle = document.querySelector<HTMLElement>('.dropdown-toggle');
    const dropdown = document.querySelector<HTMLElement>('.dropdown');

    if (!toggle || !dropdown) return;

    new Dropdown(dropdown, toggle);
})